import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface HoloPlacardProps {
  children: ReactNode;
  className?: string;
  variant?: "default" | "glow" | "accent" | "completed";
  hoverable?: boolean;
  onClick?: () => void;
  as?: "div" | "button";
}

const variantStyles = {
  default: "holo-placard",
  glow: "holo-placard holo-placard-glow",
  accent: "holo-placard holo-placard-accent",
  completed: "holo-placard holo-placard-completed",
};

const HoloPlacard = ({
  children,
  className,
  variant = "default",
  hoverable = false,
  onClick,
  as = "div",
}: HoloPlacardProps) => {
  const Tag = onClick ? "button" : as;
  return (
    <Tag
      className={cn(
        variantStyles[variant],
        hoverable && "holo-placard-hover",
        onClick && "holo-placard-hover cursor-pointer text-left w-full",
        className
      )}
      onClick={onClick}
    >
      <div className="relative z-10 overflow-visible">{children}</div>
    </Tag>
  );
};

export default HoloPlacard;
